import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=90252e42&"
import script from "./DownloadCenter.vue?vue&type=script&lang=js&"
export * from "./DownloadCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90252e42')) {
      api.createRecord('90252e42', component.options)
    } else {
      api.reload('90252e42', component.options)
    }
    module.hot.accept("./DownloadCenter.vue?vue&type=template&id=90252e42&", function () {
      api.rerender('90252e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/DownloadCenter.vue"
export default component.exports